/* System defined core library */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { UtilityService } from '../../../../shared/services/utility.service';
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

/* User defined models */
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Program } from '../../../../shared/models/scheduling/program.model';

/* User defined enums/constants */
import { ComponentType } from '../../../../shared/enums/scheduling.enum';


@Component({
  selector: 'app-program-selector',
  templateUrl: './program-selector.component.html'
})
export class ProgramSelectorComponent implements OnInit, OnChanges {

  /* User defined private/public variables  */
  public programFrm: FormGroup;
  public submitted: boolean;
  public IsCurrentFormChanged: Boolean;
  public programs: Program[];
  public errorMessage: string = '';

  /* Input-OutPut parameters decalartions */
  @Input() public client: Client;
  @Input() public inputLabel: string;
  @Input() public selectedProgram: Program;
  @Output() public getSelectedProgram: EventEmitter<Program> = new EventEmitter();

  /* Service subscriptions */
  program$: Subscription;
  programs$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private fb: FormBuilder,
    private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.programs$ = selectedExamDetailService.programs.subscribe(
      programs => {
        this.programs = programs;
      });
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.ProgramSelectorComponent)) return;

    this.getPrograms();
    this.programFrm = this.fb.group({
      'selectProgram': new FormControl('', Validators.required),
    });
    this.IsCurrentFormChanged = false;
  }

  /* Get program list from API based on  */
  getPrograms() {
    if (this.client) {
      if (!this.programs) {
        this.schedulingApiService.getPrograms(this.client.id)
          .subscribe(programs => this.programs = programs, error => this.errorMessage = <any>error);
      }
    }
  }

  /* Set selected program in shared service */
  changeProgram(program: Program): void {
    this.selectedProgram = program;
    this.selectedExamDetailService.setProgram(this.selectedProgram);
    this.getSelectedProgram.emit(this.selectedProgram);
    this.IsCurrentFormChanged = true;
  }

  /**
   * detect if selectedProgram is to null by parent and retrive programs again as per new client
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if ((changes && changes.selectedProgram && !changes.selectedProgram.currentValue)
      || (changes && !changes.selectedProgram)
    ) {
      this.selectedProgram = null;
      this.getPrograms();
    }
  }
}
